<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Évènements' | translate}}</h1>
  </div>
</div>
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title">{{'Découvrez notre dernier évènement' | translate}}</span>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <i data-dismiss="modal" class="close fas fa-times-circle"></i>
      <div class="modal-body">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" [src]="videoSrc" id="video"  allowscriptaccess="always" allow="autoplay"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>






<div class="block-featured-event py-5">
    <div class="container px-5">
        <div class="block px-4 py-5">
          <div class="container">
              <div class="row">

                <div class="col-12 col-md-7">
                  <b class="event-title">{{'Participez à nos journées portes ouvertes' | translate}}</b>
                  <p class="description mt-3">{{'Rejoignez-nous tous les jeudis après-midis pour effectuer une visite du campus virtuel aux côtés de notre Custom Success Manager, Anthony Sapin. Au cours de ces interventions, vous pourrez découvrir les nombreux espaces du campus et vous former à son utilisation. Insufflez une nouvelle dynamique à votre parcours de formation HSE avec Immersive Factory !' | translate}}</p>
                  <div class="container py-2">
                    <div class="row">
                      <div class="col-sm col-12 pl-0 ml-0 mr-2">
                        <p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/date_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Date :' | translate}}</span>{{'Chaque jeudi' | translate}}</p>
                      </div>
                      <div class="col-sm col-12 pl-0 ml-0">
                        <p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/heure_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Heure :' | translate}}</span>{{'14h30 - 15h30' | translate}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm col-12 pl-0 ml-0 mr-2">
                        <p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/langage_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Langues :' | translate}}</span>{{'Français / Anglais' | translate}}</p>
                      </div>
                      <div class="col-sm col-12 pl-0 ml-0">
                        <p class="infos-featured-event"><app-svg-icon [src]="'assets/svg/lieu_cercle.svg'" [size]="'30px'" class="fas mr-2 event-icons"></app-svg-icon><span class="bold pr-1">{{'Lieu :' | translate}}</span>{{'Campus virtuel' | translate}}</p>
                      </div>
                    </div>
                  </div>
                  <p class="mb-3 speakers">{{'Intervenant :' | translate}}</p>
                  <app-carousel-people [slides]="slides"></app-carousel-people>
                </div>

                <div class="col-12 col-md-5 mt-3 mt-md-0">
                      <picture>
                          <source srcset="{{'assets/faq-fr-anthony-events' | translate}}.webp" type="image/webp">
                          <source srcset="{{'assets/faq-fr-anthony-events' | translate}}.jpg" type="image/jpg">
                          <img src="{{'assets/faq-fr-anthony-events' | translate}}.jpg" class="block-rounded mb-2" alt="event image" title="Virtual Campus" loading="lazy"/>
                      </picture>
                      <div class="text-center btn-featured-event">
                        <a type="button" class="btn btn-download rounded-pill my-4" [href]="language.getAccountink('downloads')" title="download">
                            <i class="fas fa-download"></i>
                            <span class="mx-1"></span>
                            <span>{{'Télécharger' | translate}}</span>
                        </a>
                      </div>
                </div>

              </div>
          </div>
        </div>
    </div>
</div>




<div class="container" *ngIf="youtubeVideos">
    <div class="text-center mt-5 mb-4">
        <span class="title sub-bar">{{'Découvrez les vidéos de nos évènements' | translate}}</span>
    </div>
    <div class="videos autres mb-5">
        <div class="row ml-0 mr-0">

            <div class="col-md-4 mt-4" *ngFor="let thumbnail of youtubeVideos">
                <div class="video rounded border">
                  <div class="thumbnail" (click)="video(thumbnail.resourceId.videoId)" data-toggle="modal" data-target="#exampleModalCenter"><img class="image" src='{{thumbnail.thumbnails.medium.url}}' alt="Thumbnail of the video called {{thumbnail.title}}" title="{{thumbnail.title}}" loading="lazy"><img [src]="'assets/youtube-brands-thumbnail.svg'" class="youtube-thumbnail custom-circle" alt="Video play logo" title="Play" loading="lazy"></div>
                  <p class="youtube-title pt-4 pl-4 pr-4 pb-1">{{thumbnail.title}}</p>
                </div>
            </div>

        </div>

    </div>
</div>
<hr>
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title">{{'Découvrez tous nos évènements' | translate}}</span>
    </div>
</div>
<div class="container my-5">
    <div class="mb-2 pb-3">
        <div class="d-flex flex-column flex-md-row flex-wrap">
            <div class="col-md-6 col-lg-4 mb-4" *ngFor="let news of listNews">
                <app-actualite-card [postInfos]="news" [isRd]="isRd" [isInterview]="isInterview"></app-actualite-card>
            </div>
        </div>
        <nav class="text-center" *ngIf="listNews.length<nbPosts">
            <button class="btn btn-action" (click)="showMoreActu()">{{'Afficher plus' | translate}}</button>
        </nav>
    </div>
</div>
